import React, { forwardRef } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { getEnv } from '../../utils/environment';

const CAPTCHA_ERROR = 'hCaptcha Error: ';
const CAPTCHA_EXPIRED = 'hCaptcha Token Expired';

type HCaptchaContainerProps = {
  onExpire?: () => void;
  onError?: (error: string) => void;
};

const HCaptchaContainer = forwardRef<HCaptcha, HCaptchaContainerProps>(
  ({ onExpire, onError }, ref) => {
    const handleHCaptchaExpire = () => {
      datadogLogs.logger.error(CAPTCHA_EXPIRED);
      if (onExpire) {
        onExpire();
      }
    };
    const handleHCaptchaError = (err: any) => {
      datadogLogs.logger.error(CAPTCHA_ERROR, {}, err);
      if (onError) {
        onError(err);
      }
    };

    return (
      <form>
        <HCaptcha
          sitekey={getEnv().hCaptchaSiteKey}
          size="invisible"
          onExpire={handleHCaptchaExpire}
          onError={handleHCaptchaError}
          ref={ref}
          id="hcaptchaWidget"
        />
      </form>
    );
  },
);

export default HCaptchaContainer;
